/**
 * Check if the given number is even.
 * @param {number} value
 * @return {boolean}
 */
export default value => {
    return value % 2 === 0;
};
